import { CobranzasAxios, COMPANY, USER } from './config'

export const authUser = async (data) => {
  const res = await CobranzasAxios.post('/auth/signin', data)
  return res.data
}

export const getUserInfo = async () => {
  if (!USER || !COMPANY) return null

  const res = await CobranzasAxios.get(`/auth/validToken/${USER}/${COMPANY}`)
  return res.data
}

export const postUsers = async (data) => {
  const res = await CobranzasAxios.post(`/auth/signup/${COMPANY}`, data)
  return res.data
}

export const getUsers = async () => {
  const res = await CobranzasAxios.get(`/user/${COMPANY}`)
  return res.data
}

export const getUsersByRoles = async (role) => {
  const res = await CobranzasAxios.get(`/user/${COMPANY}/${role}`)
  return res.data
}

export const putUsers = async (data, id) => {
  const res = await CobranzasAxios.put(`/user/${id}`, data)
  return res.data
}

export const changePassword = async (data) => {
  const res = await CobranzasAxios.post('/auth/change_password', data)
  return res.data
}

export const changeUserPassword = async (userId, password) => {
  const res = await CobranzasAxios.post(`/auth/change-password/${userId}`, { password })
  return res.data
}

export const changeProfilePicture = async (data, id) => {
  const res = await CobranzasAxios.put(`/user/profile-picture/${id}`, data)
  return res.data
}
